export default "__VITE_ASSET__lBvBFe$L__"